import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

function ButtonPairSkeleton() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Skeleton variant="text" width={140} height={16} />
            <Box sx={{ display: 'flex', gap: '8px' }}>
                <Skeleton variant="rectangular" width="50%" height={34} />
                <Skeleton variant="rectangular" width="50%" height={34} />
            </Box>
        </Box>
    );
}

function CheckboxLineSkeleton() {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Skeleton variant="rectangular" width={18} height={18} />
            <Skeleton variant="text" width="60%" height={18} />
        </Box>
    );
}

function OrderCommunicationsSkeleton() {
    return (
        <div className="col-xs-12 col-md-5 col-lg-4">
            <div className="panel panel-default">
                <div className="panel-heading">
                    <Skeleton variant="text" width={160} height={24} />
                </div>
                <div className="panel-body">
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <ButtonPairSkeleton />
                        <ButtonPairSkeleton />
                        <ButtonPairSkeleton />
                        <ButtonPairSkeleton />
                        <CheckboxLineSkeleton />
                        <CheckboxLineSkeleton />
                        <CheckboxLineSkeleton />
                        <Box sx={{ display: 'flex', gap: '8px' }}>
                            <Skeleton variant="rectangular" width="70%" height={34} />
                            <Skeleton variant="rectangular" width="30%" height={34} />
                        </Box>
                        <Skeleton variant="rectangular" width="100%" height={34} />
                    </Box>
                </div>
            </div>
        </div>
    );
}

export default OrderCommunicationsSkeleton;
